import styled from 'styled-components';
const FontAwesomeSvgText = styled.text`
  /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
  font-family: FontAwesome;
  dominant-baseline: central;
  text-anchor: middle;
`;
export { FontAwesomeSvgText };
